import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "ride-preference"
};
const _hoisted_2 = {
  class: "main-wrap ride-preference-wrap"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "偏好设置", -1);
const _hoisted_4 = {
  class: "card setting-card"
};
const _hoisted_5 = {
  class: "action-sheet-select waiting-timeout-select"
};
const _hoisted_6 = {
  class: "item-status"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "item-name"
}, "出租车", -1);
const _hoisted_8 = {
  class: "item-status"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "item-name"
}, "新出租", -1);
const _hoisted_10 = {
  class: "action-sheet-select waiting-timeout-select"
};
const _hoisted_11 = {
  class: "item-status"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "item-name"
}, "5分钟", -1);
const _hoisted_13 = {
  class: "item-status"
};
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "item-name"
}, "10分钟", -1);
const _hoisted_15 = {
  class: "item-status"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "item-name"
}, "15分钟", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nav_bar = _resolveComponent("nav-bar");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_nav_bar, {
    title: $setup.title
  }, null, 8, ["title"]), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_cell, {
    title: "车型选择偏好",
    label: "设置叫车时自动选择的车型",
    onClick: _cache[0] || (_cache[0] = $event => $setup.showVehicleTypes = !$setup.showVehicleTypes),
    "is-link": ""
  }, {
    value: _withCtx(() => [!$setup.setting || !$setup.setting.orderCarTypes['ORDER_CAR_TYPE_NORMAL_TAXI'] && !$setup.setting.orderCarTypes['ORDER_CAR_TYPE_ONLINE_TAXI'] ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createTextVNode(_toDisplayString("未设置"))], 64)) : _createCommentVNode("", true), $setup.setting && $setup.setting.orderCarTypes['ORDER_CAR_TYPE_NORMAL_TAXI'] && !$setup.setting.orderCarTypes['ORDER_CAR_TYPE_ONLINE_TAXI'] ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createTextVNode(_toDisplayString("出租车"))], 64)) : _createCommentVNode("", true), $setup.setting && $setup.setting.orderCarTypes['ORDER_CAR_TYPE_ONLINE_TAXI'] && !$setup.setting.orderCarTypes['ORDER_CAR_TYPE_NORMAL_TAXI'] ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [_createTextVNode(_toDisplayString("新出租"))], 64)) : _createCommentVNode("", true), $setup.setting && $setup.setting.orderCarTypes['ORDER_CAR_TYPE_NORMAL_TAXI'] && $setup.setting.orderCarTypes['ORDER_CAR_TYPE_ONLINE_TAXI'] ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 3
    }, [_createTextVNode(_toDisplayString("全部"))], 64)) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_component_van_cell, {
    title: "应答车型偏好",
    label: "多车型应答优先选择的车型",
    value: "综合优先",
    "is-link": ""
  }), _createVNode(_component_van_cell, {
    title: "超时自动取消",
    label: "超过设置时长自动取消叫车",
    value: $setup.setting.waitingTimeout ? $setup.setting.waitingTimeout + '分钟' : '未设置',
    onClick: _cache[1] || (_cache[1] = $event => $setup.showWaitingTimeout = !$setup.showWaitingTimeout),
    "is-link": ""
  }, null, 8, ["value"])])]), _createVNode(_component_van_action_sheet, {
    show: $setup.showVehicleTypes,
    "onUpdate:show": _cache[4] || (_cache[4] = $event => $setup.showVehicleTypes = $event),
    description: "选中下列车型后，在叫车时会自动为您选中",
    "cancel-text": "确定",
    "close-on-click-action": "",
    onCancel: _cache[5] || (_cache[5] = $event => $setup.showVehicleTypes = false)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
      class: "action-sheet-select-item",
      onClick: _cache[2] || (_cache[2] = $event => $options.selectVehicleTypes('ORDER_CAR_TYPE_NORMAL_TAXI'))
    }, [_createElementVNode("div", _hoisted_6, [$setup.setting && $setup.setting.orderCarTypes['ORDER_CAR_TYPE_NORMAL_TAXI'] ? (_openBlock(), _createBlock(_component_van_icon, {
      key: 0,
      name: "success"
    })) : _createCommentVNode("", true)]), _hoisted_7]), _createElementVNode("div", {
      class: "action-sheet-select-item",
      onClick: _cache[3] || (_cache[3] = $event => $options.selectVehicleTypes('ORDER_CAR_TYPE_ONLINE_TAXI'))
    }, [_createElementVNode("div", _hoisted_8, [$setup.setting && $setup.setting.orderCarTypes['ORDER_CAR_TYPE_ONLINE_TAXI'] ? (_openBlock(), _createBlock(_component_van_icon, {
      key: 0,
      name: "success"
    })) : _createCommentVNode("", true)]), _hoisted_9])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_action_sheet, {
    show: $setup.showWaitingTimeout,
    "onUpdate:show": _cache[9] || (_cache[9] = $event => $setup.showWaitingTimeout = $event),
    description: "选择超时自动取消时长",
    "cancel-text": "确定",
    "close-on-click-action": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
      class: "action-sheet-select-item",
      onClick: _cache[6] || (_cache[6] = $event => $options.selectWaitingTimeout(5))
    }, [_createElementVNode("div", _hoisted_11, [$setup.setting && $setup.setting.waitingTimeout === 5 ? (_openBlock(), _createBlock(_component_van_icon, {
      key: 0,
      name: "arrow"
    })) : _createCommentVNode("", true)]), _hoisted_12]), _createElementVNode("div", {
      class: "action-sheet-select-item",
      onClick: _cache[7] || (_cache[7] = $event => $options.selectWaitingTimeout(10))
    }, [_createElementVNode("div", _hoisted_13, [$setup.setting && $setup.setting.waitingTimeout === 10 ? (_openBlock(), _createBlock(_component_van_icon, {
      key: 0,
      name: "arrow"
    })) : _createCommentVNode("", true)]), _hoisted_14]), _createElementVNode("div", {
      class: "action-sheet-select-item",
      onClick: _cache[8] || (_cache[8] = $event => $options.selectWaitingTimeout(15))
    }, [_createElementVNode("div", _hoisted_15, [$setup.setting && $setup.setting.waitingTimeout === 15 ? (_openBlock(), _createBlock(_component_van_icon, {
      key: 0,
      name: "arrow"
    })) : _createCommentVNode("", true)]), _hoisted_16])])]),
    _: 1
  }, 8, ["show"])]);
}